import { useEffect } from 'react';

import { useEventCallback } from '../../common/utils/hooks';

/**
 * For a child of a data wrapper (DetailContainer, CreatorContainer) whose
 * primary action belongs in the parent's design `Screen` dock: reports
 * `{ hint, action }` to `onDockChange` (a useState setter in the parent), so
 * the dock renders through `Screen`'s `dock` prop and the measured footer keeps
 * the sync banner above it. Reports null on unmount (loading, error, leaving).
 * Pass `isVisible: false` to hide the dock. `onPress` may change every render.
 */
const useReportDockAction = (onDockChange, {
	isVisible = true,
	hint,
	label,
	onPress,
	loading,
	disabled,
	icon,
}) => {
	const handlePress = useEventCallback((...args) => onPress?.(...args));

	useEffect(() => {
		if (onDockChange) {
			onDockChange(isVisible ? { hint, action: { label, onPress: handlePress, loading, disabled, icon } } : null);
		}
	}, [onDockChange, isVisible, hint, label, handlePress, loading, disabled, icon]);

	useEffect(() => () => {
		if (onDockChange) {
			onDockChange(null);
		}
	}, [onDockChange]);
};

export default useReportDockAction;
